import {InstrumentDataUpdate, type Symbol} from '@qep/types/src';

export enum SourceKind {
  Data = 'Data',
  Fx = 'Fx',
}

export type ISource<T = any> = {
  readonly ready: boolean;
  readonly value: T;
  subscribe(onData?: (value: T) => void): void;
  unsubscribe(): void;
};

export class ConstantSource<T = any> implements ISource<T> {
  constructor(public value: T) {}

  get ready() {
    return true;
  }

  subscribe(onData?: (data: T) => void) {
    onData?.(this.value);
  }

  unsubscribe() {
    // no-op
  }
}

export class InstrumentSource<P = Symbol, T = InstrumentDataUpdate> implements ISource<T> {
  private _ready = false;
  private _value?: T;
  private readonly _unsubscribes: Function[] = [];

  constructor(private readonly _params: P) {}

  get value(): T {
    return this._value!;
  }

  get ready(): boolean {
    return this._ready;
  }

  subscribe(onData?: (value: T) => void) {
    const subs = globalThis.QEP.apiServices.marketdata.subscribeToInstrumentData([this._params as Symbol], (_err: unknown, data: InstrumentDataUpdate) => {
      if (!data) {
        return;
      }

      this._ready = true;
      this._value = data;
      onData?.(data);
    });
    this._unsubscribes.push(...subs);
  }

  unsubscribe() {
    for (const unsub of this._unsubscribes.splice(0)) {
      unsub();
    }
  }
}
